export const OPEN_DELAY = 600;
export const CLOSE_DELAY = 300;